<div class="p-table-wrapper">
  @if (title() || subtitle() || filterable() || exportable() || showFiltersToggle() || showAddButton()) {
  <div class="p-table-toolbar w-full">
    @if (title() || subtitle()) {
      <div class="p-table-toolbar__left">
        @if (title()) {
        <h2 class="p-table-title sub-title-h2">{{ titleText }}</h2>
        }
        @if (subtitle()) {
        <p class="p-table-subtitle text-xs">{{ subtitleText }}</p>
        }
      </div>
    }
    <div class="flex gap-2 flex-wrap w-full">
      @if (filterable()) {
      <div class="p-table-search-inline">
        <p-inputgroup class="p-table-search-group w-full" [id]="searchBoxId">
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input pInputText type="text" [ngModel]="globalFilter()" (ngModelChange)="onGlobalFilter($event)"
            (keyup.enter)="applySearch()" placeholder="Search..." class="text-xs" />
        </p-inputgroup>
      </div>
      }
      <!-- @if (showSearchButton) {
            <button pButton pRipple type="button" icon="pi pi-search" label="Search" class="p-button-sm"
              [outlined]="true" severity="secondary" (click)="applySearch()"></button>
          }
        @if (showFiltersToggle) {
          <button pButton pRipple type="button" icon="pi pi-filter" label="Filters" class="p-button-sm"
            [outlined]="!filtersVisible()" [severity]="filtersVisible() ? 'primary' : 'secondary'"
            (click)="toggleFilters()"></button>
        } -->
      <!-- @if (exportable()) {
      <button pButton pRipple type="button" icon="pi pi-download" label="Resync" class="p-button-sm" [outlined]="true"
        severity="secondary" (click)="resyncData()"></button>
      }
      @if (exportable()) {
      <button pButton pRipple type="button" icon="pi pi-download" label="Export" class="p-button-sm" [outlined]="true"
        severity="secondary" (click)="exportCsv()"></button>
      }
      @if (showAddButton()) {
      <button pButton pRipple type="button" [icon]="addButtonIcon()" [label]="addButtonLabel()" class="p-button-sm"
        severity="primary" (click)="addEntry.emit()"></button>
      } -->
    </div>
  </div>
  }
  <p-table #dt [value]="data()" [columns]="visibleColumns()" [paginator]="paginator()" [rows]="rows()"
    [rowsPerPageOptions]="rowsPerPageOptions()" [paginatorDropdownAppendTo]="'body'" [showJumpToPageDropdown]="true"
    [globalFilterFields]="globalFilterFields().length ? globalFilterFields() : visibleColumns().map(c => c.field)"
    [selectionMode]="selectionMode()" [selection]="selection()" [dataKey]="dataKey()" [lazy]="lazy()"
    [expandedRowKeys]="expandedRows()"
    [loading]="loading()" [totalRecords]="totalRecords()" [rowHover]="true" [first]="first()" [scrollable]="scrollable()"
    [scrollHeight]="scrollable() ? getTableHeightByPage() : undefined"
    (window:reload)="getTableHeightByPage()" (window:resize)="getTableHeightByPage()" [sortField]="sortField()"
    [sortOrder]="sortOrder()" [styleClass]="styleClass()"
    [showCurrentPageReport]="paginator()"
    [currentPageReportTemplate]="currentPageReportTemplate() || `${paginationInfo().start} - ${paginationInfo().end} of ${paginationInfo().total} items`"
    (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" (onLazyLoad)="onLazyLoad($event)"
    (onPage)="onPageChange($event)" (onSort)="onSortChange($event)" (selectionChange)="onSelectionChange($event)"
    (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)" [size]="'large'" (window:reload)="getTableHeightByPage()" (window:resize)="getTableHeightByPage()">
    @if (captionTemplate) {
    <ng-template pTemplate="caption">
      <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
    </ng-template>
    }

    <ng-template pTemplate="header" let-columns>
      <tr>
        @if (hasExpand()) {
        <th style="width: 3rem"></th>
        }
        @if (hasCheckbox()) {
        <th style="width: 3rem">
          <p-tableHeaderCheckbox />
        </th>
        }
        @if (headerTemplate) {
        <th [attr.colspan]="columns.length + (hasCheckbox() ? 1 : 0) + (hasExpand() ? 1 : 0)" class="p-table-body-custom-td">
          <ng-container *ngTemplateOutlet="headerTemplate; context: { columns: columns }"></ng-container>
        </th>
        } @else {
        <th class="text-xs sub-title-h2" style="width: 3.5rem"
          [class.p-table-cell-sticky]="stickyColumns()" [class.p-table-cell-sticky--start]="stickyColumns()">
          <div class="p-table-th-content">
            <span class="text-xs">#</span>
          </div>
        </th>
        @for (col of columns; track col.field) {
        <th class="text-xs sub-title-h2" [pSortableColumn]="col.sortable !== false && sortable() ? col.field : undefined"
          [pSortableColumnDisabled]="col.sortable === false || !sortable()"
          [ngClass]="[col.class || '', col.type === 'number' || col.type === 'percent' ? 'p-table-num' : '', stickyClasses(col)]"
          [ngStyle]="col.style" [style.width.%]="col.width">
          <div class="p-table-th-content">
            <span class="text-xs">{{ columnHeaderText(col) }}</span>
            @if (col.sortable !== false && sortable()) {
            <p-sortIcon [field]="col.field" />
            }
          </div>
        </th>
        }
        }
      </tr>
      @if (filtersVisible() && !headerTemplate) {
      <tr class="p-table-filters-row">
        @if (hasExpand()) {
        <th style="width: 3rem"></th>
        }
        @if (hasCheckbox()) {
        <th style="width: 3rem"></th>
        }
        <th style="width: 3.5rem" [class.p-table-cell-sticky]="stickyColumns()"
          [class.p-table-cell-sticky--start]="stickyColumns()"></th>
        @for (col of columns; track col.field) {
        <th [ngClass]="[col.class || '', col.type === 'number' ? 'p-table-num' : '', stickyClasses(col)]">
          @if (col.filterable !== false && col.type !== 'html') {
          <input pInputText type="text" [ngModel]="columnFilters()[col.field] ?? ''"
            (ngModelChange)="onColumnFilter(col.field, $event)" [placeholder]="'Filter ' + columnHeaderText(col) + '...'"
            class="p-table-col-filter text-xs" />
          }
        </th>
        }
      </tr>
      }
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="selectionMode() ? rowData : undefined" class="p-table-row"
        (click)="onRowClick(rowData)" [ngClass]="rowClassFn(rowData)">
        @if (hasExpand()) {
        <td style="width: 3rem">
          <button type="button" pButton pRipple [pRowToggler]="rowData"
            class="p-button-text p-button-rounded p-button-sm"
            [icon]="expandedRows()[rowData[dataKey()]] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        }
        @if (hasCheckbox()) {
        <td>
          <p-tableCheckbox [value]="rowData" />
        </td>
        }
        @if (bodyTemplate) {
        <td [attr.colspan]="columns.length + (hasCheckbox() ? 1 : 0) + (hasExpand() ? 1 : 0)" class="p-table-body-custom-td">
          <ng-container
            *ngTemplateOutlet="bodyTemplate; context: { $implicit: rowData, columns: columns, index: rowIndex }"></ng-container>
        </td>
        } @else {
        <td style="width: 3.5rem" [class.p-table-cell-sticky]="stickyColumns()"
          [class.p-table-cell-sticky--start]="stickyColumns()">{{ first() + rowIndex + 1 }}</td>
        @for (col of columns; track col.field) {
        @if (rowspanFor(col, rowIndex) !== 0) {
        <td class="text-sm" [attr.rowspan]="rowspanFor(col, rowIndex)"
          [ngClass]="[col.class || '', col.type === 'number' || col.type === 'percent' ? 'p-table-num' : '', stickyClasses(col)]"
          [ngStyle]="col.style" [style.width.%]="col.width">
          @if (cellTemplate) {
          <ng-container
            *ngTemplateOutlet="cellTemplate; context: { $implicit: rowData, col: col, index: rowIndex }"></ng-container>
          } @else {
          @switch (col.type) {
          @case ('status') {
          <span class="p-table-status" [attr.data-status]="rowData[col.statusField || col.field]">
            {{ rowData[col.field] ?? '-' }}
          </span>
          }
          @case ('date') {
          <span class="p-table-date">
            <i class="pi pi-calendar"></i> {{ rowData[col.field] | date:'medium' }}
          </span>
          }
          @case ('percent') {
          <div class="p-table-pct">
            <span class="p-table-pct__value">{{ (rowData[col.field] ?? 0) * 100 | number: '1.0-0' }}%</span>
            @if (col.showBar) {
            <div class="p-table-pct__bar" role="presentation">
              <div class="p-table-pct__bar-fill"
                [style.width.%]="(rowData[col.barField || col.field] ?? rowData[col.field] ?? 0) * 100"
                [attr.data-tier]="rowData[col.tierField || col.field]"></div>
            </div>
            }
          </div>
          }
          @default {
          @if (col.dotField && rowData[col.dotField]) {
          <span class="data-table__dot p-table-dot" [style.background]="rowData[col.dotField]"
            aria-hidden="true"></span>
          }
          <span>{{ rowData[col.field] ?? '-' }}</span>
          }
          }
          }
        </td>
        }
        }
        }
      </tr>
    </ng-template>

    @if (expandable()) {
    <ng-template pTemplate="expandedrow" let-rowData>
      <tr>
        <td [attr.colspan]="visibleColumns().length + (hasCheckbox() ? 1 : 0) + (hasExpand() ? 1 : 0) + 1">
          <ng-container *ngTemplateOutlet="expandedRowTemplate || rowExpansionTemplate; context: { $implicit: rowData }"></ng-container>
        </td>
      </tr>
    </ng-template>
    }

    @if (emptyTemplate) {
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="visibleColumns().length + (hasCheckbox() ? 1 : 0) + (hasExpand() ? 1 : 0) + 1">
          <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
        </td>
      </tr>
    </ng-template>
    } @else {
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="visibleColumns().length + (hasCheckbox() ? 1 : 0) + (hasExpand() ? 1 : 0) + 1"
          class="p-table-empty text-center">
          <div class="p-table-empty__content">
            <i class="pi pi-inbox"></i>
            <span class="text-xs">{{ emptyMessage() }}</span>
          </div>
        </td>
      </tr>
    </ng-template>
    }
  </p-table>
</div>